import React, { Component } from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import DeviceCard from '../elements/DeviceCard';
import Button from '../elements/Button';
import SendButton from '../elements/SendButton';
import Heading from '../elements/PageHeading';

const Form = styled.div`
  text-align: center;
  margin-bottom: 30px;
`;

const Label = styled.h1`
  text-align: center;
  margin: 10px auto;
  font-size: 16px;
  color: ${props => props.theme.primary};
`;
const Select = styled.select`
  position: relative;
  font-family: Arial, sans-serif;
  margin: 5px auto 0px;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const Option = styled.option`
  display: inline-block;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  width: 200px; /* Set the width as needed */
  background-color: #fff; /* Background color */
  cursor: pointer; /* Add cursor on hover */
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: auto;
  color: ${props => props.theme.secondary};
`;

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 50px auto 0px;
  width: 360px;
`;

const Attention = styled.div`
  background: ${props => props.theme.attentionTint};
  color: ${props => props.theme.secondary};
  width: 360px;
  padding: 15px;
  box-sizing: border-box;
  margin: 20px auto 0px;
  text-align: center;
`;

class RetirePage extends Component {
  render() {
    const { t, target, cancel, retire, onChange, retireReason } = this.props;

    return (
      <Wrapper>
        <Heading text={t('management.retire')} />
        <DeviceCard device={target || {}} />
        <Form>
          <Label>{t('management.retired_reason')} </Label>
          <Select defaultValue={retireReason} onChange={onChange}>
            <Option value="1">{t('management.scrapped')}</Option>
            <Option value="2">{t('management.hwReplaced')}</Option>
            <Option value="3">{t('management.toStock')}</Option>
            <Option value="4">{t('management.returnToSelfly')} </Option>
            <Option value="100">{t('management.other')}</Option>
          </Select>
        </Form>
        <div>
          <Attention>{t('management.retire_warning')}</Attention>
          <Buttons>
            <Button onClick={cancel}>{t('button.cancel')}</Button>
            <SendButton onClick={() => retire()} text={t('button.confirm')} />
          </Buttons>
        </div>
      </Wrapper>
    );
  }
}

export default translate()(RetirePage);
